import LottieAnimation from 'react-lottie'

export default function Lottie({ animation, options = { loop: false }, ...props }){

    let animationData

    switch(animation){
        case 'password': animationData = require('assets/lotties/password.json'); break;
        case 'identity': animationData = require('assets/lotties/identity.json'); break;
        case 'permissions': animationData = require('assets/lotties/permissions.json'); break;
        case 'block': animationData = require('assets/lotties/block.json'); break;
        case 'employees': animationData = require('assets/lotties/employees.json'); break;
        case 'notification': animationData = require('assets/lotties/notification.json'); break;
        case 'empty': animationData = require('assets/lotties/empty.json'); break;
        case 'sun': animationData = require('assets/lotties/sun.json'); break;
        case 'moon': animationData = require('assets/lotties/moon.json'); break;
        case 'montage': animationData = require('assets/lotties/montage.json'); break;
        case 'shipping': animationData = require('assets/lotties/shipping.json'); break;
        case 'done': animationData = require('assets/lotties/done.json'); break;
        case 'withdraw': animationData = require('assets/lotties/withdraw.json'); break;
        case 'warehouse': animationData = require('assets/lotties/warehouse.json'); break;
        case 'waiting': animationData = require('assets/lotties/waiting.json'); break;
        case 'search-card': animationData = require('assets/lotties/search-card.json'); break;
        case 'quotation': animationData = require('assets/lotties/quotation.json'); break;
    }

    return <LottieAnimation options={{ animationData, ...options }} {...props} />
}